'use strict';

export const USERS_LOADED = 'user/USERS_LOADED';
export const USERS_LOADING_FAILED = 'user/USERS_LOADING_FAILED';